import { render, staticRenderFns } from "./RegulatoryUpdateSuccess.vue?vue&type=template&id=03b18797"
import script from "./RegulatoryUpdateSuccess.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateSuccess.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports